import { ReactElement, useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Dialog } from "@mui/material";

import {
  LogoImg,
  ModalTitle,
  ModalMessage,
  ModalFooter,
} from "./styles/SoldOutModalStyles";

import MarkLogo from "../../assets/images/MarkLogo.png";

import COLORS from "../../theme/Colors";

import { registerLimitService } from "../../api/Register";

const SoldOutModal = ({ setState }: ISoldOutModalProps): ReactElement => {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const handleCheckRegister = async () => {
    try {
      const response = await registerLimitService();
      if (!response.available) {
        setShowDialog(true);
        if(setState !== undefined) {
          setState(response.available);
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    handleCheckRegister();
  }, []);

  return (
    <Dialog open={showDialog}>
      <IconButton
        sx={{ alignSelf: "flex-end", padding: "16px" }}
        aria-label="close"
        onClick={() => setShowDialog(false)}
      >
        <CloseIcon sx={{ color: COLORS.primary }} />
      </IconButton>
      <div
        style={{
          justifyContent: "center",
          padding: "32px",
          paddingTop: 0,
          textAlign: "center",
        }}
      >
        <LogoImg style={{ maxWidth: "300px" }} src={MarkLogo} />
        <ModalTitle>¡Se ha alcanzado el limite de registros!</ModalTitle>
        <ModalMessage>
          ¡Atención golfistas! Nos complace anunciar que hemos alcanzado el
          límite máximo de participantes registrados para nuestro próximo torneo
          de golf.
        </ModalMessage>
        <ModalFooter>
          ¡Gracias por su interés en formar parte de esta extraordinaria
          experiencia!
        </ModalFooter>
      </div>
    </Dialog>
  );
};

export type ISoldOutModalProps = {
  setState?: (state: boolean) => void;
};
export default SoldOutModal;
